import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { PatientInsightsCard } from './PatientInsightsCard';

// Emerald matches the "paid"/success hue used by billing's collected-amount
// chart, so an approval reads as a positive outcome next to the navy
// submissions bars.
const APPROVALS_COLOR = '#059669';

interface ApprovalsInsightCardProps {
    practiceId: string;
}

export function ApprovalsInsightCard({ practiceId }: ApprovalsInsightCardProps) {
    return (
        <PatientInsightsCard
            practiceId={practiceId}
            metricLabel="Approvals"
            metric="approvals"
            icon={CheckCircleIcon}
            color={APPROVALS_COLOR}
        />
    );
}
